import React from 'react';
import './AutomationContent.css';

const automationFeatures = [
    {
        title: "Skylight Blinds",
        image: "/Assets/AutomationImages/skylight.webp",
        content: `After the hustle and bustle of city life there’s nothing better than coming home and waking up to bright spaces and clear – calming views of the beautiful sky above. Callistus Skylight Blinds with automation are the perfect solution to that need. With the help of Remote Control user can preset and easily operate window blinds individually with just a press of a button.`
    },
    {
        title: "Colby Day & Night, TDBU",
        image: "/Assets/AutomationImages/day-night-automation.webp",
        content: `<b>Callistus Colby Blinds</b> that are specially designed to control light not only horizontally from bottom to up but also there is a system of bringing this blinds from up to bottom. Hence such Day & Night feature promotes the ease of light control in better way. Automation used in such blinds is also advanced and with our high end solution based approach Callistus provide the finest Automation.`
    },
    {
        title: "Wooden Venetian Blinds",
        image: "/Assets/AutomationImages/wooden.webp",
        content: `With Wooden Venetian, one can achieve astonishing gradients of light in 180 degrees in horizontal direction. Wooden Venetian Blinds are the contemporary look creator that adds exotic touch to the interiors. With tilting of vanes it can also be closed or opened horizontally like roller blinds automation.`
    },
    {
        title: "Home Automation",
        image: "/Assets/AutomationImages/home-automation.webp",
        content: `Home automation is the new age demand. With home automation today user can control from switching off light to controlling window blinds with a single touch of a screen. There are too many options for HA devices and instruments in today’s market and the demand for quality and easiness have also been increasing.`
    },
    {
        title: "Precise Control with a Remote",
        image: "/Assets/AutomationImages/precise-control-with-a-remote.webp",
        content: `Remote Control allows you to preset and easily operate up-to sixteen different groupings of window blinds, individually or together with just a press of a button. Available in different colours to enhance any decor and can be affixed to a wall.`
    },
    {
        title: "Fix a Wall Switch",
        image: "/Assets/AutomationImages/fix-a-wall-switch.webp",
        content: `Our stylish selection of wall switches is the simplest way to operate Callistus Window blinds. They are perfect for anyone worried about misplacing their controls and are available in different frames and colours to complement your interiors.`
    },
    {
        title: "Wire free motorization",
        image: "/Assets/AutomationImages/wire-free-motors.webp",
        content: `<b>Benefits of wire free motor in Blinds</b><br />
                 – Feature for a long-life and rechargeable batteries.<br />
                 – Optimize your space and ambiance.<br />
                 – Play with different mood and protect your privacy<br />
                 – Offers child and pet safety.<br />
                 – You can enjoy perfect peace and quiet atmosphere.`
    },
    {
        title: "Curtain Motor",
        image: "/Assets/AutomationImages/cutrain-track-2-1.webp",
        content: `Curtain motors are very crucial to understand as the type of motors to be used depends on lots of factors like the weight of fabric, the length of channel etc. Callistus Blinds provides motors for curtain with keeping in minds such conditions.`
    },
    {
        title: "Seirra Blinds",
        image: "/Assets/AutomationImages/sierra-motors.webp",
        content: `<b>Callistus Sierra Blinds</b> are the outstanding invention that gives the feeling of curtains and the benefit of blinds. They are the perfect choice for Big Windows or French doors. Also the motor specifications of Sierra blinds are excellent. Minimal sound and swiftness in operation makes Sierra blinds stand out as a masterpiece.`
    },
    {
        title: "Child Friendly",
        image: "/Assets/AutomationImages/child-friendly.webp",
        content: `Making window blinds safer for homes with infants and young children has always been a priority for Callistus. Simple cord free operation is aesthetically pleasing & safer for children and pets. Make your home decor safe for children and let them roam around freely.`
    },
    {
        title: "Vertical Blinds",
        image: "/Assets/AutomationImages/vertical-1-1.webp",
        content: `<b>Vertical blinds</b> are the best choice when we want to control light into 180 degrees in vertical motion. Motor used in Vertical blinds are specifically designed to make vertical movement and easiness.`
    },
    {
        title: "Architectural Window Blinds Automation",
        image: "/Assets/AutomationImages/Heavy-Blinds-automation.webp",
        content: `<b>Callistus</b> have designed special automation solution exclusively characterized to lift the weight of fabric and blinds used in Big Architectural Windows.`
    }
];

const AutomationContent = () => {
    return (
        <div className="Automation-pg-content">
            <div className="Automation-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Automation Solution</h1>
                </div>

                <div className="Automation-full-image">
                    <img src="/Assets/AutomationImages/automation-main-page.webp" alt="Energy efficient windows" />
                </div>

                <div className="Automation-Sec-Subtitle">
                    <p>
                        With the advent of new and advanced technology, human being’s inclination to make life easier is increasing.
                        Automation is the technology by which a process or procedure is performed with minimal human assistance. Hence
                        Callistus Blinds believe is accessing the high end automation systems in the Blinds for easy and swift light control.
                    </p>
                </div>

                <div className="Automation-features">
                    {automationFeatures.map((item, index) => (
                        <div className="Automation-feature-row" key={index}>
                            <h4>{item.title}</h4>
                            <div className="Automation-card">
                                <div className="Automation-feature-image">
                                    <img src={item.image} alt={item.title} />
                                </div>
                                <div className="Automation-feature-text">
                                    <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default AutomationContent;
